import Container from '../lib/gui/dom/Container';
import EpgConstants from './../Nepg/EpgConstants';

export default class TimeIndicatorController {

    constructor(parentController, domParent) {
        this.eventGridController = parentController;
        this.bar = new Container(domParent);
        this.bar.addClassName('nepg-time-indicator');
        this.bar.hide();
    }

    hide() {
        this.bar.hide();
    }

    show() {
        this.bar.show();
    }

    updatePosition(_now) {
        let ileft = 0;
        let startTime = this.eventGridController.getStartTime() * 1000;
        let timewin_length = this.eventGridController.getTimeWindowLength();
		if (this.timeInGridWindowTime(_now)) {
            _now = _now * 1000;
            ileft = Math.round((_now - startTime) / timewin_length * EpgConstants.ROW_WIDTH);
            this.bar.setStyle({left: ileft + 'px'});
			this.show();
        } 
        else {
			this.hide();
		}
    }

    timeInGridWindowTime(time) {
		return this.eventGridController.isInCurrentWindow(time);
	}
}


// WEBPACK FOOTER //
// ./src/AAF/Nepg/TimeIndicatorController.js